import styled from '../../styled-components';

export const Text = styled.div`
  margin-bottom: 25px;
  font-size: 18px;
  color: ${({ theme }) => theme.color.midnight};
`;
